import { EPageMenuType } from '@hts/shared/enums';
import { IMappedMenu } from '@hts/shared/types';
import { useMemo } from 'react';

export const useGetTopMenus = (menus: IMappedMenu[] = []) => {
  const { topMenu1, topMenu2 } = useMemo(
    () => ({
      topMenu1: menus.find((menu) => menu.type === EPageMenuType.TOP_MENU_1),
      topMenu2: menus.find((menu) => menu.type === EPageMenuType.TOP_MENU_2),
    }),
    [menus]
  );

  return { topMenu1, topMenu2 };
};
